<template>
  <div id="mb-monograph" :style="[startGameConfig.type ? {} : { zIndex: 8 }]">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
      }"
    />
    <div class="main-container">
      <div class="letters-container">
        <div class="letters-and-numbers" v-if="!startGameConfig.type">
          <div class="letters-select">
            <div
              :value="itm"
              class="letter-select-item"
              @click="
                select = itm;
                onChange(select, 'letter');
              "
              v-for="(itm, index) in items"
              :key="'letter-itm-' + index"
            >
              {{ itm.id }}
            </div>
          </div>
          <div class="numbers-select">
            <div
              :value="itm"
              class="number-select-item"
              @click="
                select = itm;
                onChange(select, 'number');
              "
              v-for="(itm, index) in itemsNumber"
              :key="'number-select-' + index"
            >
              {{ itm.id }}
            </div>
          </div>
        </div>
        <svg
          style="z-index: 4"
          v-if="item"
          xmlns="http://www.w3.org/2000/svg"
          width="calc(1920px/4)"
          height="calc(1920px/4)"
          viewBox="0 0 1066.6667 1066.6667"
        >
          <g transform="matrix(1.3333333,0,0,-1.3333333,0,1066.6667)">
            <g v-if="startGameConfig.type == 'letter'">
              <path d="M 0,0 H 800 V 800 H 0 Z" style="fill: #ffffff" />
              <path transform="translate(0,609.5)" d="M 0,0 H 800" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(0,420)" d="M 0,0 H 800" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(0,230)" d="M 0,0 H 800" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(0,39.5)" d="M 0,0 H 800" stroke-width="2" stroke="#00ffff" />
            </g>
            <g v-if="startGameConfig.type == 'number'">
              <path d="M 0,0 H 800 V 800 H 0 Z" style="fill: #ffffff" />
              <path transform="translate(302.5332,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(492.8311,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(111.9863,419.5615)" d="M 0,0 H 570.346" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(112.4404,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(682.332,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(683.0342,230)" d="M 0,0 H -570.594" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(683.0342,609.1084)" d="M 0,0 H -570.594" stroke-width="2" stroke="#00ffff" />
            </g>
            <g v-for="(it, index) in item.paths" :key="'monography-path-' + index" :transform="it.transform">
              <path
                :class="{ handWriting: show }"
                :id="'letter-path-' + index"
                :stroke="it.stroke"
                :stroke-width="it.strokeWidth"
                :style="{
                  animationDelay: 1 + it.delay + 's',
                  animationDuration: it.strokeDasharray / 200 + 's',
                  fill: 'none',
                  opacit: 0,
                  'stroke-dasharray': it.strokeDasharray,
                  'stroke-dashoffset': it.strokeDasharray,
                }"
                :d="it.path"
              />
              <circle
                r="5"
                fill="red"
                class="circle"
                :style="{ animationDelay: 1 + it.delay + 's', animationDuration: it.strokeDasharray / 200 + 's' }"
              >
                <animateMotion
                  :id="'anim-' + index"
                  fill="freeze"
                  :dur="it.strokeDasharray / 200 + 's'"
                  :begin="1.05 + it.delay + 's'"
                  repeatCount="1"
                  :path="it.path"
                />
              </circle>
            </g>
            <path
              class="arrow"
              v-for="(arr, indexAr) in item.arrows"
              :key="'monography-arrows-' + indexAr"
              :transform="arr.transform"
              stroke="#ff00ff"
              stroke-width="3"
              :style="{
                animationDelay:
                  2 +
                  item.paths[item.paths.length - 1].delay +
                  item.paths[item.paths.length - 1].strokeDasharray / 200 +
                  's',
                fill: 'none',
              }"
              :d="arr.path"
            />
          </g>
        </svg>
        <svg
          style="z-index: 4"
          v-if="item"
          xmlns="http://www.w3.org/2000/svg"
          width="calc(1920px/2)"
          height="calc(1920px/4)"
          id="drawing-svg"
          viewBox="0 0 1066.6667 1066.6667"
          @mousemove="onMouseMove($event)"
          @mousedown="canIDrow = true"
          @mouseleave="endOfPath()"
          @mouseup="endOfPath()"
          @touchmove="onMouseMove($event, true)"
          @touchstart="canIDrow = true"
          @touchend="endOfPath()"
          @touchleave="endOfPath()"
          @touchcancel="endOfPath()"
        >
          <g style="transform: matrix(1.3333333, 0, 0, -1.3333333, -530, 1066.6667)">
            <g v-if="startGameConfig.type == 'letter'">
              <path d="M 0,0 H 1600 V 800 H 0 Z" style="fill:#ffffff; calc(1920px/2); height: calc(1920px/4)" />
              <path transform="translate(0,609.5)" d="M 0,0 H 1600" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(0,420)" d="M 0,0 H 1600" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(0,230)" d="M 0,0 H 1600" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(0,39.5)" d="M 0,0 H 1600" stroke-width="2" stroke="#00ffff" />
            </g>
            <g v-if="startGameConfig.type == 'number' && select.id != 'ten'">
              <path
                d="M 0,0 H 1600 V 800 H 0 Z"
                style="fill: #ffffff; width: calc(1920px / 2); height: calc(1920px / 4)"
              />
              <path transform="translate(302.5332,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(492.8311,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(111.9863,419.5615)" d="M 0,0 H 1328.3493" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(112.4404,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(682.332,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(871.8329,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1061.3338,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1250.8347,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1440.3356,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(111.9863,230)" d="M 0,0 H 1328.3493" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(111.9863,609.1084)" d="M 0,0 H 1328.3493" stroke-width="2" stroke="#00ffff" />
            </g>
            <g v-if="select.id == 'ten'">
              <path
                d="M 0,0 H 1600 V 800 H 0 Z"
                style="fill: #ffffff; width: calc(1920px / 2); height: calc(1920px / 4)"
              />
              <path transform="translate(202.5332,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(392.8311,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(011.9863,419.5615)" d="M 0,0 H 1520" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(012.4404,229.0146)" d="M 0,0 V 381.094" stroke-width="2" stroke="#00ffff" />
              <path transform="translate(582.332,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(771.8329,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(961.3338,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1150.8347,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1340.3356,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(1529.8365,229.0146)" d="M 0,0 V 381.094" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(11.9863,230)" d="M 0,0 H 1520" stroke-width="4" stroke="#00ffff" />
              <path transform="translate(11.9863,609.1084)" d="M 0,0 H 1520" stroke-width="2" stroke="#00ffff" />
            </g>
            <g
              v-for="(it, index) in item.paths"
              :key="'monography-path-' + index"
              :transform="'translate(' + (it.translateX - item.minTranslateX / 2) + ',' + it.translateY + ')'"
            >
              <path
                :id="'letter-path-' + index"
                stroke="black"
                :stroke-width="it.strokeWidth"
                :style="{
                  fill: 'none',
                  opacity: 0.3,
                  'stroke-linecap': 'round',
                  'stroke-linejoin': 'round',
                  'stroke-miterlimit': '2.613',
                }"
                :d="it.path"
              />
            </g>
          </g>
          <polyline
            :points="draw.path"
            style="cursor: pointer"
            fill="none"
            :stroke="draw.stroke"
            :stroke-opacity="draw.opacity"
            :stroke-width="draw.strokeWidth"
            v-for="(draw, index) in drawingPath"
            :key="'draw-path-' + index"
          />
        </svg>
      </div>
    </div>
    <div
      v-if="!startGameConfig.type"
      class="icon-container-small"
      @mouseenter="exitIconHover = true"
      @mouseleave="exitIconHover = false"
    >
      <img draggable="false" class="exit-icon controll-icon-small" @click="closeMonogtaph()" :src="exitIcon" />
      <transition name="icon-fade">
        <img
          draggable="false"
          v-if="exitIconHover"
          class="controll-icon-small"
          @click="closeMonogtaph()"
          :src="exitIconOn"
        />
      </transition>
    </div>
    <div class="select-items" v-if="selectItem.length > 0">
      <div
        @click="
          select = selIt.item;
          onChange(select, selIt.type);
        "
        v-for="(selIt, selItIndex) in selectItem"
        class="select-item"
        :key="'selected-items-' + selItIndex"
      >
        {{ selIt.show }}
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import defaultMixin from '__mainSrcDir/components/TrGame/v4/mixins/defaultMixin';
export default {
  name: 'mb-monograph',
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  components: {},
  data: function () {
    return {
      drawingPath: [{ path: '', strokeWidth: 4, stroke: 'black', opacity: 1 }],
      item: null,
      canIDrow: false,
      items: null,
      itemsNumber: null,
      select: null,
      prevRoute: null,
      show: false,
      exitIconHover: false,
      type: '',
      selectItem: [],
    };
  },
  mounted() {
    let tmp;
    let tmpNumber;
    try {
      tmp = require('__mainSrcDir/config/monographConfig/letters.config.js').default;
    } catch (error) {
      console.log('%clettersConfig - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
    }
    try {
      tmpNumber = require('__mainSrcDir/config/monographConfig/numbers.config.js').default;
    } catch (error) {
      console.log('%cnumbersConfig - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
    }
    if (tmp && tmpNumber) {
      this.items = tmp;
      this.itemsNumber = tmpNumber;
      this.setDelay();
      this.setNumberDelay();
    } else {
      this.$router.push(`/`);
    }
    this.setPath();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      // console.log(from);
    });
  },
  methods: {
    resetGameAction() {
      this.resetSetPath();
    },
    resetSetPath() {
      let tmpIt = this.item;
      this.item = null;
      this.drawingPath = [{ path: '', strokeWidth: 4, stroke: 'black', opacity: 1 }];
      setTimeout(() => {
        this.show = false;
        this.item = tmpIt;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }, 50);
    },
    setPath() {
      setTimeout(() => {
        if (this.startGameConfig.type) {
          if (Array.isArray(this.startGameConfig.select)) {
            this.selectItem = [];
            this.startGameConfig.select.forEach((it) => {
              if (this.startGameConfig.type == 'letter') {
                let tmp = it.split('_');
                let tmpIt = tmp[0];
                if (tmp[1] == 'big') tmpIt = tmpIt.toUpperCase();
                let selectedItem = null;
                this.items.forEach((itm) => {
                  if (itm.id == it) {
                    selectedItem = itm;
                  }
                });
                this.selectItem.push({ id: it, show: tmpIt, item: selectedItem, type: this.startGameConfig.type });
              } else {
                let tmpIt = '0';
                switch (it) {
                  case 'zero':
                    tmpIt = '0';
                    break;
                  case 'one':
                    tmpIt = '1';
                    break;
                  case 'two':
                    tmpIt = '2';
                    break;
                  case 'three':
                    tmpIt = '3';
                    break;
                  case 'four':
                    tmpIt = '4';
                    break;
                  case 'five':
                    tmpIt = '5';
                    break;
                  case 'six':
                    tmpIt = '6';
                    break;
                  case 'seven':
                    tmpIt = '7';
                    break;
                  case 'eight':
                    tmpIt = '8';
                    break;
                  case 'nine':
                    tmpIt = '9';
                    break;
                  case 'ten':
                    tmpIt = '10';
                    break;
                }
                let selectedItem = null;
                this.itemsNumber.forEach((itm) => {
                  if (itm.id == it) {
                    selectedItem = itm;
                  }
                });
                this.selectItem.push({ id: it, show: tmpIt, item: selectedItem, type: this.startGameConfig.type });
              }
            });
            this.select = this.selectItem[0].item;
            this.onChange(this.select, 'letter');
          } else {
            if (this.startGameConfig.type == 'letter') {
              this.items.forEach((it) => {
                if (it.id == this.startGameConfig.select) {
                  this.select = it;
                }
              });
            } else {
              this.itemsNumber.forEach((it) => {
                if (it.id == this.startGameConfig.select) {
                  this.select = it;
                }
              });
            }
            this.onChange(this.select, 'letter');
          }
        }
      }, 500);
    },
    endOfPath() {
      // this.active.path = false;
      this.canIDrow = false;
      this.drawingPath.push({
        path: '',
        strokeWidth: 4,
        stroke: 'black',
        opacity: 1,
      });
    },
    onMouseMove(e, touch) {
      if (this.canIDrow) {
        let rect = document.getElementById('drawing-svg').getBoundingClientRect();
        let posX = (e.clientX - rect.left) / rect.width;
        let posY = (e.clientY - rect.top) / rect.height;
        if (touch) {
          posX = (e.targetTouches[0].clientX - rect.left) / rect.width;
          posY = (e.targetTouches[0].clientY - rect.top) / rect.height;
        }
        // console.log(posX + ' : ' + posY);
        this.drawingPath[this.drawingPath.length - 1].path =
          this.drawingPath[this.drawingPath.length - 1].path + (2130 * posX - 530) + ', ' + 1066 * posY + ' ';
      }
    },
    setPathLength(id) {
      setTimeout(() => {
        let path = document.getElementById(id).getTotalLength();
        // console.log(id + '  : ' + path);
        return path;
      }, 1);
    },
    createTranslateCoordintae(string) {
      let tmpString = '';
      tmpString = string;
      tmpString = tmpString.replace('translate(', '');
      tmpString = tmpString.replace(')', '');
      tmpString = tmpString.split(',');
      return tmpString;
    },
    setDelay() {
      this.items.forEach((el) => {
        let time = 0;
        el.minTranslateX = 999999;
        el.paths.forEach((path) => {
          path.delay = time;
          time = time + path.strokeDasharray / 200;
          let tmpString = this.createTranslateCoordintae(path.transform);
          path.translateX = parseInt(tmpString[0]);
          path.translateY = parseInt(tmpString[1]);
          if (path.translateX < el.minTranslateX) el.minTranslateX = path.translateX;
        });
      });
    },
    setNumberDelay() {
      this.itemsNumber.forEach((el) => {
        let time = 0;
        el.minTranslateX = 379.0018;
        el.paths.forEach((path) => {
          path.delay = time;
          time = time + path.strokeDasharray / 200;
          let tmpString = this.createTranslateCoordintae(path.transform);
          path.translateX = parseInt(tmpString[0]);
          path.translateY = parseInt(tmpString[1]);
          if (el.id == 'ten') {
            path.translateX = path.translateX + 91;
          }
          // if (path.translateX < el.minTranslateX) el.minTranslateX = path.translateX;
        });
      });
    },
    onChange(it, type) {
      this.item = null;
      this.type = type;
      this.drawingPath = [{ path: '', strokeWidth: 4, stroke: 'black', opacity: 1 }];
      this.$nextTick(() => {
        this.show = false;
        this.item = it;
      });
      setTimeout(() => {
        this.show = true;
      }, 50);
    },
    closeMonogtaph() {
      if (this.prevRoute) {
        if (this.prevRoute.fullPath == '/') this.redirectMain();
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
      } else {
        this.redirectMain();
      }
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbMonograph- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbMonograph- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-monograph
  width: 100%
  position: absolute
  top: 0
  height: 100%
  // z-index: 8
  background: #ffd100
  background: #ffd100
  font-family: $gameFontFamily
  .select-items
    position: absolute
    width: 100%
    bottom: 0
    left: 0
    height: 120px
    display: flex
    align-items: center
    justify-content: center
    .select-item
      margin: 0px 20px
      display: flex
      align-items: center
      justify-content: center
      width: 100px
      height: 100px
      background: #004899
      color: white
      border-radius: 10px
      box-shadow: 0px 0px 7px rgba(0,0,0, 0.2)
      font-family: $gameFontFamily
      cursor: pointer
      font-size: 34px
      transition: .5s
      &:hover
        box-shadow: 0px 0px 9px rgba(0,0,0, 0.8)
  .main-img
    position: absolute
    object-fit: cover
  .letter-select, .number-select
    position: absolute
    top: 0
    left: 0
  .number-select
    top: 28px
  .main-container
    width: 84%
    height: 56%
    background: white
    top: 22%
    left: 8%
    border-radius: 10px
    box-shadow: 0px 0px 7px rgba(0,0,0, 0.2)
    position: absolute

    .letters-container
      width: 100%
      height: 100%
      display: flex
      align-items: center
      justify-content: space-evenly
      .letters-and-numbers
        position: absolute
        top: 0
        left: 0
        width: 20%
        height: 26%
        background: #f2f2f2
        filter: drop-shadow(10px 10px 10px rgba(0,0,0, .4))
        .letters-select, .numbers-select
          display: inline-block
          width: 50%
          max-height: 100%
          overflow-y: scroll
          .letter-select-item, .number-select-item
            margin: 5px
            padding: 10px 20px
            transition: .5s
            background: #f2f2f2
            cursor: pointer
            font-size: 24px
            &:hover
              background: gray
  .icon-container-small, .icon-container
    display: inline-block
    position: absolute
    top: 40px
    right: 30px
    width: 48px
    height: 48px

    .controll-icon, .controll-icon-small
      position: absolute
      top: 0
      left: 0
      width: 48px
      height: 48px
      transition: .5s
      // transform: scale(.9)
      cursor: pointer
    .controll-icon-small
      width: 32px
      height: 32px
      margin-top: -15px
      margin-left: 20px

@keyframes iconShow
  0%
    opacity: 0
    transform: rotate(-25deg) scale(.9)
  50%
    opacity: 1
    transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1

.handWriting
  opacity: 1
  animation: dash 1s linear forwards
  stroke-linecap: round
  stroke-linejoin: round
  stroke-miterlimit: 2.613
@keyframes dash
  to
    stroke-dashoffset: 0
.circle
  animation: dashCircle 1.2s linear
  opacity: 0
@keyframes dashCircle
  0%
    opacity: 1
  100%
    opacity: 1
.arrow
  animation: dashArrow 1s linear forwards
  opacity: 0
@keyframes dashArrow
  to
    opacity: 1
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
